<template>
  <transition
    name="fade"
    mode="out-in"
  >
    <div class="find-service-view">
      <services-map />
    </div>
  </transition>
</template>

<script>
import ServicesMap from '~/ServicesMap';

export default {
  components: {
    ServicesMap,
  },
};
</script>
